module.exports = __webpack_public_path__ + "static/media/whats_logo.c9fbc2ec.png";